import {
  PUBLISH_DATA_WITH_AUTH,
  PUBLISH_DATA_WITH_AUTH_SUCCESS,
  PUBLISH_DATA_WITH_AUTH_ERROR,
  PUBLISH_DATA_WITH_AUTH_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const PublishDataWithAuth = (state = initialState, action) => {
  switch (action.type) {
    case PUBLISH_DATA_WITH_AUTH:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case PUBLISH_DATA_WITH_AUTH_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case PUBLISH_DATA_WITH_AUTH_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case PUBLISH_DATA_WITH_AUTH_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default PublishDataWithAuth;
